$(function() {
  const $hamburger = $('.js-hamburger');
  const $menu = $('.js-menu');
  const $menuWrapper = $('#menus');
  const $searchInputWrapper = $('.js-search-input-wrapper');
  const $searchIcon = $('.js-search-icon');

  const toggleMenu = function() {
    $searchInputWrapper.addClass('js-dn');
    $searchIcon.removeClass('active');

    $menu.toggleClass('js-dn');
    $menuWrapper.toggleClass('menu-active');
    $hamburger.toggleClass('active');

    // Send data to GA
    dataLayer.push({
      event: 'Menu',
      action: 'MenuMobileToggle',
      type: $menu.hasClass('js-dn') ? 'close' : 'open'
    });
  };

  $hamburger.on('click', e => toggleMenu());
});
